__turbopack_context__.v({
  "activeIndicator": "SidebarMenu-module__ScFmkG__activeIndicator",
  "icon": "SidebarMenu-module__ScFmkG__icon",
  "iconBadge": "SidebarMenu-module__ScFmkG__iconBadge",
  "iconWrapper": "SidebarMenu-module__ScFmkG__iconWrapper",
  "item": "SidebarMenu-module__ScFmkG__item",
  "itemActive": "SidebarMenu-module__ScFmkG__itemActive",
  "itemInactive": "SidebarMenu-module__ScFmkG__itemInactive",
  "list": "SidebarMenu-module__ScFmkG__list",
  "nav": "SidebarMenu-module__ScFmkG__nav",
  "navReady": "SidebarMenu-module__ScFmkG__navReady",
  "textContainer": "SidebarMenu-module__ScFmkG__textContainer",
  "textContainerCompact": "SidebarMenu-module__ScFmkG__textContainerCompact",
  "textContainerExpanded": "SidebarMenu-module__ScFmkG__textContainerExpanded",
  "textLabel": "SidebarMenu-module__ScFmkG__textLabel",
});
